import { render, staticRenderFns } from "./batch-update.vue?vue&type=template&id=49536e1a&scoped=true"
import script from "./batch-update.vue?vue&type=script&lang=js"
export * from "./batch-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49536e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49536e1a')) {
      api.createRecord('49536e1a', component.options)
    } else {
      api.reload('49536e1a', component.options)
    }
    module.hot.accept("./batch-update.vue?vue&type=template&id=49536e1a&scoped=true", function () {
      api.rerender('49536e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/batch-update.vue"
export default component.exports